export { PageHead, PageHeadProps } from '@thesisedu/web'
